<h3 class="text-center bg-c-yellow">Counselling Dashboard</h3>
<div class="container mt-5 mis-dashboard">

  <!-- ─── Filters ─── -->
  <section>
    <div class="d-flex gap-2 flex-wrap align-items-center mb-3">

      <!-- Date Range Picker -->
      <mat-form-field appearance="outline">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
          <input matEndDate [(ngModel)]="endDate" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Counsellor Type</mat-label>
        <mat-select [(ngModel)]="counsellorsType" (selectionChange)="onCounsellorTypeChange($event)">
          <mat-option value="Active">Active Counsellors</mat-option>
          <mat-option value="All">All Counsellors</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-mini-fab color="accent" (click)="onSearch()">
        <mat-icon>search</mat-icon>
      </button>

      <button mat-mini-fab color="warn" (click)="onClear()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </section>

  <!-- ─── Date range label ─── -->
  <div class="text-center mb-3">
    <span class="badge bg-secondary" style="font-size:13px; padding: 6px 16px;">
      <i class="fas fa-calendar-alt me-1"></i> Data shown for: <strong>{{ dateRangeLabel }}</strong>
    </span>
  </div>

  <!-- ─── Session Count Cards (from counsellingMonthlySummary) ─── -->
  <div class="row">
    <!-- Individual Sessions -->
    <div class="col-lg-3 col-sm-6">
      <div class="info-box7 l-bg-card1 order-info-box7 scale-on-hover">
        <div class="info-box7-block">
          <h4 class="m-b-20">Individual Sessions</h4>
          <h2 class="text-end">
            <i class="fas fa-user float-start"></i>
            <span>{{tableIndividualTotal}}</span>
          </h2>
        </div>
      </div>
    </div>

    <!-- Group Sessions -->
    <div class="col-lg-3 col-sm-6">
      <div class="info-box7 l-bg-card2 order-info-box7 scale-on-hover">
        <div class="info-box7-block">
          <h4 class="m-b-20">Group Sessions</h4>
          <h2 class="text-end">
            <i class="fas fa-users float-start"></i>
            <span>{{tableGroupTotal}}</span>
          </h2>
        </div>
      </div>
    </div>

    <!-- Follow-Up Sessions -->
    <div class="col-lg-3 col-sm-6">
      <div class="info-box7 l-bg-card3 order-info-box7 scale-on-hover">
        <div class="info-box7-block">
          <h4 class="m-b-20">Follow-Up Sessions</h4>
          <h2 class="text-end">
            <i class="fas fa-redo float-start"></i>
            <span>{{tableFollowUpTotal}}</span>
          </h2>
        </div>
      </div>
    </div>

    <!-- Assessments -->
    <div class="col-lg-3 col-sm-6">
      <div class="info-box7 l-bg-card4 order-info-box7 scale-on-hover">
        <div class="info-box7-block">
          <h4 class="m-b-20">Assessments</h4>
          <h2 class="text-end">
            <i class="fas fa-clipboard-list float-start"></i>
            <span>{{tableAssessmentTotal}}</span>
          </h2>
        </div>
      </div>
    </div>

    <!-- Total Sessions Summary -->
<!--    <div class="col-lg-3 col-sm-6 mt-3">-->
<!--      <div class="info-box7 order-info-box7 scale-on-hover" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">-->
<!--        <div class="info-box7-block">-->
<!--          <h4 class="m-b-20">Sessions Summary</h4>-->
<!--          <h2 class="text-end">-->
<!--            <i class="fas fa-chart-line float-start"></i>-->
<!--            <span>{{tableTotalSessions}}</span>-->
<!--          </h2>-->
<!--          <div class="m-b-0 d-flex justify-content-between" style="font-size: 12px;">-->
<!--            <div>Observed: {{tableObservedTotal}}</div>-->
<!--            <div>Assessments: {{tableAssessmentTotal}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>

  <!-- ─── Counsellor Table ─── -->
  <section>

    <!-- ─── Counsellor Table ─── -->
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">

      <!-- No -->
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>Sr.No.</th>
        <td mat-cell *matCellDef="let row;let i=index">{{ i+1 }}</td>
        <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
      </ng-container>

      <!-- Photo -->
      <ng-container matColumnDef="photo">
        <th mat-header-cell *matHeaderCellDef>Photo</th>
        <td mat-cell *matCellDef="let row">
          <img [src]="getPhoto(row.profileImages)"
               (error)="onImageError($event)"
               [alt]="row.userName || 'Profile image'"
               style="width:40px;height:40px;border-radius:50%; border: 1px solid" />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>Counsellor Name</th>
        <td mat-cell *matCellDef="let row">
          <b [style.font-style]="row.isSynthetic || row.disabled ? 'italic' : 'normal'">{{ getDisplayName(row) }}</b>
          <span *ngIf="row.isSynthetic || row.disabled" class="badge bg-warning text-dark ms-1" style="font-size: 10px;"
                matTooltip="This user is not in the system or is disabled">⚠</span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
<!--    COMMENTED      <small class="text-muted">Ind: {{tableIndividualTotal}} &nbsp;|&nbsp; Grp: {{tableGroupTotal}} &nbsp;|&nbsp; FU: {{tableFollowUpTotal}}</small>-->
        </td>
      </ng-container>

      <!-- Joining Date -->
      <ng-container matColumnDef="joiningDate">
        <th mat-header-cell *matHeaderCellDef>Joining Date</th>
        <td mat-cell *matCellDef="let row">{{ formatJoiningDate(row.joiningDate) }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Centre -->
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef>Alloted Centres</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.centre?.length <= 1">
            {{ row.centre.join(', ') }}
          </ng-container>

          <ng-container *ngIf="row.centre?.length > 1">
            <span *ngIf="!row.expanded">
              {{ row.centre.slice(0, 1).join(', ') }}
              <a style="color: #3f51b5; cursor: pointer;" (click)="toggleCentre(row)">
                + Read more
              </a>
            </span>

            <span *ngIf="row.expanded">
              {{ row.centre.join(', ') }}
              <a style="color: #3f51b5; cursor: pointer;" (click)="toggleCentre(row)">
                Read less
              </a>
            </span>
          </ng-container>
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <b>Total</b>
        </td>
      </ng-container>

      <!-- Total Sessions -->
      <ng-container matColumnDef="totalSessionCount">
        <th mat-header-cell *matHeaderCellDef>Total Sessions</th>
        <td mat-cell *matCellDef="let row"><b>{{ formatZero(row.sessionCount + row.individualCount + row.followUpCount) }}</b></td>
        <td mat-footer-cell *matFooterCellDef><b>{{ tableTotalSessions }}</b></td>
      </ng-container>

      <!-- Session Observed (only for Krisha Shah and Vaishali Nanda) -->
      <ng-container matColumnDef="SessionObservedCount">
        <th mat-header-cell *matHeaderCellDef>Session Observed</th>
        <td mat-cell *matCellDef="let row">
          <b *ngIf="row.userName === 'Krisha Shah' || row.userName === 'Vaishali Nanda' || row.userName === 'Krisha' || row.userName === 'Vaishali'">{{ formatZero(row.sessionObserve) }}</b>
          <span *ngIf="row.userName !== 'Krisha Shah' && row.userName !== 'Vaishali Nanda' && row.userName !== 'Krisha' && row.userName !== 'Vaishali'">-</span>
        </td>
        <td mat-footer-cell *matFooterCellDef><b>{{ tableObservedTotal }}</b></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="counsellorColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: counsellorColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="counsellorColumns" style="background:#f5f5f5; font-weight:bold;"></tr>

    </table>

  </section>
  <br>

  <!-- ─── Session Attribution Report ─── -->
  <section *ngIf="debugReport && showDebugButton">
    <div class="d-flex align-items-center gap-3 mb-2">
      <button mat-stroked-button color="primary" (click)="showDebugPanel = !showDebugPanel">
        <mat-icon>{{ showDebugPanel ? 'visibility_off' : 'analytics' }}</mat-icon>
        {{ showDebugPanel ? 'Hide' : 'Show' }} Session Attribution Report
        <span class="badge bg-danger ms-1" *ngIf="debugReport.diff.total > 0">
          {{ debugReport.diff.total }} unaccounted
        </span>
        <span class="badge bg-success ms-1" *ngIf="debugReport.diff.total === 0">✓ Fully accounted</span>
      </button>
    </div>

    <div *ngIf="showDebugPanel" class="p-3 border rounded" style="background:#fafafa;">

      <!-- Summary row -->
      <div class="row mb-3 text-center">
        <div class="col-md-4">
          <div class="card border-secondary">
            <div class="card-body py-2">
              <div class="text-muted" style="font-size:12px;">RAW (summaryDocs total)</div>
              <strong>Ind: {{debugReport.rawTotals.individual}} &nbsp;|&nbsp;
                      Grp: {{debugReport.rawTotals.group}} &nbsp;|&nbsp;
                      FU:  {{debugReport.rawTotals.followUp}}</strong>
              <div><span class="badge bg-secondary">Total: {{debugReport.rawTotals.total}}</span></div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card border-primary">
            <div class="card-body py-2">
              <div class="text-muted" style="font-size:12px;">CARDS (shown on dashboard)</div>
              <strong>Ind: {{debugReport.cardTotals.individual}} &nbsp;|&nbsp;
                      Grp: {{debugReport.cardTotals.group}} &nbsp;|&nbsp;
                      FU:  {{debugReport.cardTotals.followUp}}</strong>
              <div><span class="badge bg-primary">Total: {{debugReport.cardTotals.total}}</span></div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card" [ngClass]="debugReport.diff.total > 0 ? 'border-danger' : 'border-success'">
            <div class="card-body py-2">
              <div class="text-muted" style="font-size:12px;">DIFFERENCE (Raw − Cards)</div>
              <strong [style.color]="debugReport.diff.individual > 0 ? '#dc3545' : 'inherit'">
                Ind: {{debugReport.diff.individual}} &nbsp;|&nbsp;
                Grp: {{debugReport.diff.group}} &nbsp;|&nbsp;
                FU:  {{debugReport.diff.followUp}}
              </strong>
              <div>
                <span class="badge" [ngClass]="debugReport.diff.total > 0 ? 'bg-danger' : 'bg-success'">
                  Total: {{debugReport.diff.total}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No discrepancy message -->
      <div *ngIf="debugReport.logs.length === 0" class="alert alert-success">
        ✅ No attribution needed — all sessions already matched to counsellors correctly.
      </div>

      <!-- Attribution log table -->
      <div *ngIf="debugReport.logs.length > 0">
        <p class="fw-bold mb-2" style="color:#0d6efd;">
          ℹ️ {{debugReport.logs.length}} attribution entries — sessions reassigned or unmatched:
        </p>
        <div class="table-responsive">
          <table class="table table-sm table-bordered table-hover" style="font-size:13px;">
            <thead class="table-dark">
              <tr>
                <th>#</th>
                <th>Attribution</th>
                <th>Original Counsellor Name</th>
                <th>Normalized Key</th>
                <th>Centre</th>
                <th>Docs</th>
                <th class="text-end">Individual</th>
                <th class="text-end">Group</th>
                <th class="text-end">Follow-Up</th>
                <th class="text-end">Sub-Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of debugReport.logs; let i = index"
                  [ngClass]="getLogRowClass(log.reason)">
                <td>{{i+1}}</td>
                <td>
                  <span class="badge" [ngClass]="getLogBadgeClass(log.reason)">
                    {{log.reason}}
                  </span>
                </td>
                <td><em>{{log.counsellorName}}</em></td>
                <td><code>{{log.normalizedKey || '—'}}</code></td>
                <td>{{log.centreCode || '—'}}</td>
                <td class="text-center">{{log.docCount ?? '—'}}</td>
                <td class="text-end fw-bold">{{log.individual}}</td>
                <td class="text-end fw-bold">{{log.group}}</td>
                <td class="text-end fw-bold">{{log.followUp}}</td>
                <td class="text-end fw-bold">{{log.individual + log.group + log.followUp}}</td>
              </tr>
            </tbody>
            <tfoot class="table-secondary fw-bold">
              <tr>
                <td colspan="6" class="text-end">Sessions attributed to Krisha Shah:</td>
                <td class="text-end">{{ totalAttributedIndividual }}</td>
                <td class="text-end">{{ totalAttributedGroup }}</td>
                <td class="text-end">{{ totalAttributedFollowUp }}</td>
                <td class="text-end">{{ totalAttributedIndividual + totalAttributedGroup + totalAttributedFollowUp }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <p class="text-muted" style="font-size:11px;">
          Generated: {{debugReport.generatedAt | date:'dd MMM yyyy, hh:mm:ss a'}} &nbsp;|&nbsp;
          Mode: <strong>{{counsellorsType}}</strong> &nbsp;|&nbsp;
          Date range: <strong>{{dateRangeLabel}}</strong>
        </p>
        <div class="alert alert-light border mt-2" style="font-size:12px;">
          <strong>Attribution Legend:</strong><br>
          🔵 <strong>Empty Name (→ Krisha Shah)</strong> — Summary docs with null/empty <code>counsellorName</code>. Sessions counted under Krisha Shah.<br>
          🔵 <strong>Excluded Name (→ Krisha Shah)</strong> — Sessions filed under system accounts (admin, na, etc.). Counted under Krisha Shah.<br>
          🟡 <strong>Unmatched (Active Mode)</strong> — Counsellor has sessions in summary but no active employee record (only in Active mode).
        </div>
      </div>
    </div>
  </section>

  <br>
  <hr>
  <br>
  <br>

  <section>
    <app-session-count-report></app-session-count-report>
  </section>
</div>
